import { useTranslation } from 'react-i18next';
import {
  useInterventionActionCreateMutation,
  useInterventionActionDestroyMutation,
  useInterventionActionUpdateMutation,
  useInterventionBulkCloseMutation,
  useInterventionCategoryCreateMutation,
  useInterventionCreateMutation,
  useInterventionDestroyMutation,
  useInterventionUpdateMutation,
} from 'graphql-common';
import { showGraphQLErrors } from '@lib/utils/graphQLErrors';

export default function useMutations() {
  const { t } = useTranslation();

  const [interventionCreateMutation, interventionCreateMutationResult] =
    useInterventionCreateMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  const [interventionUpdateMutation, interventionUpdateMutationResult] =
    useInterventionUpdateMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  const [interventionDestroyMutation, interventionDestroyMutationResult] =
    useInterventionDestroyMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  const [interventionBulkCloseMutation, interventionBulkCloseMutationResult] =
    useInterventionBulkCloseMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  const [
    interventionActionCreateMutation,
    interventionActionCreateMutationResult,
  ] = useInterventionActionCreateMutation({
    onError: (error) => showGraphQLErrors(error, t),
  });

  const [
    interventionActionUpdateMutation,
    interventionActionUpdateMutationResult,
  ] = useInterventionActionUpdateMutation({
    onError: (error) => showGraphQLErrors(error, t),
  });

  const [
    interventionActionDestroyMutation,
    interventionActionDestroyMutationResult,
  ] = useInterventionActionDestroyMutation({
    onError: (error) => showGraphQLErrors(error, t),
  });

  const [categoryCreateMutation, categoryCreateMutationResult] =
    useInterventionCategoryCreateMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  return {
    interventionActionCreateMutation,
    interventionActionCreateMutationResult,
    interventionActionDestroyMutation,
    interventionActionDestroyMutationResult,
    interventionActionUpdateMutation,
    interventionActionUpdateMutationResult,
    interventionBulkCloseMutation,
    interventionBulkCloseMutationResult,
    interventionCreateMutation,
    interventionCreateMutationResult,
    interventionDestroyMutation,
    interventionDestroyMutationResult,
    interventionUpdateMutation,
    interventionUpdateMutationResult,
    categoryCreateMutation,
    categoryCreateMutationResult,
  };
}
